import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { CartProduct } from "../../assets/icons/icons";
import axios from "axios";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
export default function ProductGridTwo() {
    const { t,i18n } = useTranslation();
    UseScrollAnimation();

    const [filter, setFilter] = useState("all");
    const [dataFilter, setDataFilter] = useState([]);
    const [dataAccessories, setDataAccessories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/accessoriesCategory");
                setDataFilter([
                    { accessories_category_name_E: 'All', accessories_category_name_A: 'الكل', accessories_category_id: 'all' },
                    ...response.data.accessories_category
                ]);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        const fetchAccessories = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/accessories");
                setDataAccessories(response.data.accessories);
            }
            catch (error) {
                console.error("Error fetching accessories:", error);
            }
        };

        fetchAccessories();
    }, []);

    const filteredData = dataAccessories.filter((el) => {
        if (filter === "all") return true;
        return el.accessories_category_id === parseInt(filter);
    });

    const [visibleCount, setVisibleCount] = useState(7);
    const isShowingAll = visibleCount >= filteredData.length;

    const toggleCategories = () => {
        if (isShowingAll) {
            setVisibleCount(isMobile ? 4 : 7);
        } else {
            setVisibleCount(filteredData.length);
        }
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) {
            setVisibleCount(4);
        } else {
            setVisibleCount(7);
        }
    }, [isMobile]);

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    const showData = filteredData.slice(0, visibleCount).map((el, index) => {
        const priceAfterDiscount = (el.accessories_price * (1 - el.accessories_price_discount / 100)).toFixed(2);
        const inventoryClass = el.accessories_stock_available === 0 ? "text-red-500" : "text-[#18AB00]";
        const accessoriesName = getLocalizedText({ A: el.accessories_name_A, E: el.accessories_name_E });
        const accessoriesDesc = getLocalizedText({ A: el.accessories_desc_A, E: el.accessories_desc_E });

        return (
            <Link key={index} to={`/accessoriesdetails/${el.accessories_id}`} className="w-165 flex flex-col h-auto bg-[#f6f6f6] w-[250px] overflow-hidden border-[1px] justify-between border-[#d1d1d1] rounded-[4px]">
                <div className="w-165 h-165 w-[250px] h-[250px] relative">
                    <div className="w-165 h-165 w-[250px] h-[250px] border-b-[1px] border-b-[#1485a6]">
                        <img className="w-full h-full object-contain" src={`https://laravel-api.aj-mart.com/storage/app/public/${el.accessories_main_img}`} alt="" />
                    </div>
                    <div className="w-des w-10 h-10 bg-[#1485a6] rounded-full text-white font-bold flex items-center justify-center absolute top-[10px] right-[10px]">
                    {el.accessories_price_discount * 1}%
                    </div>
                </div>
                <div className="p-[10px]">
                    <div className="font-15 text-[18px] font-bold text-center text-center capitalize">{accessoriesName}</div>
                    <p className="font-10 direction-ar-rt text-[13px] text-[#666666] text-center">
                        {t(`${accessoriesDesc.length > 75 ? accessoriesDesc.substring(0, 75) + '...' : accessoriesDesc}`)}
                        
                    </p>
                    <div className="font-14 flex items-center justify-center gap-[5px] text-center">
                        <span className={`font-bold ${inventoryClass}`}>{priceAfterDiscount} <span>{t("JOD")}</span></span>
                        <span className="line-through">{el.accessories_price} <span>{t("JOD")}</span></span>
                    </div>
                    <div className="font-12 text-center font-bold">
                        {t(`${el.accessories_stock_available > 0 ? "In Stock" : "Out of Stock"}`)}
                    </div>
                </div>
                <Link
                    to={`/accessoriesdetails/${el.accessories_id}`}
                    className={`bg-[#1485a6] flex p-1.5 items-center justify-center gap-1.5 text-white font-bold rounded-tl-[20px] rounded-tr-[20px] transition-opacity duration-300`}
                >
                    <CartProduct />
                    {t("Add To Cart")}
                </Link>
            </Link>
        );
    });

    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex flex-col gap-[10px] justify-center">
                    <div className="text-[35px] font-bold text-white">{t("All Product")} </div>
                    <div className="flex items-center gap-[3px] text-white">
                        <Link to={"/"}>{t("Home")}</Link>
                        <span>-</span>
                        <div>{t("All Product")} </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container">
                    <div className="flex flex-col gap-[15px]">
                        <div>
                            <Swiper
                                slidesPerView="auto"
                                spaceBetween={10}
                                navigation={false}
                                loop={false}
                                style={isMobile ? { direction: "ltr" } : {}}
                            >
                                {dataFilter.map(item => (
                                    <SwiperSlide key={item.accessories_category_id} style={{ width: "fit-content" }}>
                                        <button
                                            className={`filter ${filter === item.accessories_category_id ? "active" : ""}`}
                                            onClick={() => setFilter(item.accessories_category_id)}
                                            style={{
                                                padding: "10px 20px",
                                                whiteSpace: "nowrap",
                                                border: "1px solid #ddd",
                                                borderRadius: "5px",
                                            }}
                                        >
                                            {t(i18n.language === "ar" ? item.accessories_category_name_A : item.accessories_category_name_E)}
                                        </button>
                                    </SwiperSlide>
                                ))}

                            </Swiper>
                        </div>

                        <div className="flex flex-wrap gap-[10px] justify-start je-center">
                            {showData}
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}